import GedcomX from '../../../../../shared/helpers/gedcom_X'
import { getYearsDiffDates } from '../../../../../shared/helpers/factDate_Helper'

const gcx = GedcomX()

// We use NO_AGE to signify that an age will not be _displayed_. A "life event" is the user-facing summary of a fact.
// This is useful for facts like burial, which takes place after death and after aging has stopped
const NO_AGE = -Number.MAX_VALUE

const transformers = {
  [gcx.BIRTH]: { eventType: 'Birth', translationKey: gcx.BIRTH, age: 0 },
  [gcx.DEATH]: {
    eventType: 'Death',
    translationKey: gcx.DEATH,
  },
  [gcx.BURIAL]: {
    eventType: 'Burial',
    translationKey: gcx.BURIAL,
    age: NO_AGE,
  },
  [gcx.RESIDENCE]: residenceFactTransformer,
}

export default function mapFactToLifeEvent({ ...args }) {
  if (!args?.fact?.display?.type || !(args.fact.display.type in transformers)) {
    return null
  }

  let year
  try {
    year = args.fact.display.date.year
  } catch (e) {
    // console.log('Bad year')  // eslint-disable-line
  }

  const transformer = transformers[args.fact.display.type]

  // use buildStaticFact if transformer is specified by an object
  return typeof transformer === 'function'
    ? transformer({ year, ...args })
    : buildStaticFactTransformer({ year, ...transformer, ...args })
}

function buildStaticFactTransformer({ ...args }) {
  let calculatedAge = null
  if (!args.age) {
    // If no age is specified, we calculate an age by event year and birth date
    calculatedAge = getAgeAtEvent(args.fact, args.birthDate)
  } else if (args.age !== NO_AGE) {
    calculatedAge = args.age
  }

  return staticTranslatedFactTransformer({ ...args, age: calculatedAge })
}

function staticTranslatedFactTransformer({
  fact,
  eventType,
  translations,
  translationKey,
  year,
  age,
  description,
  name,
}) {
  const translation = translations[translationKey]

  // If we don't have a translation or a name or a description, fail silently
  if (!translation && (!name || !description)) {
    return null
  }

  return {
    place: fact.display.place,
    event: name ?? translation.name,
    eventType,
    year,
    age,
    description: description ?? translation.description,
  }
}

function residenceFactTransformer({ fact, translations, birthDate, year }) {
  if (fact.display.place === '' && fact.display.placeFull === '') {
    return undefined
  }

  const age = getAgeAtEvent(fact, birthDate)
  const translation = translations[gcx.RESIDENCE]

  return {
    place: fact.display.place !== '' ? fact.display.place : fact.display.placeFull,
    event: translation.name,
    year,
    eventType: `Residence`,
    age,
    description: translation.description(fact, year, age),
  }
}

function getAgeAtEvent(fact, birthDate) {
  // We don't check birthDate or eventDate for truthy because getYearsDiffDates does
  // Instead, check if getYearsBetweenDates is null
  if (!fact?.display?.date?.normalized) {
    return 'Unknown'
  }

  const eventDate = new Date(fact.display.date.normalized)
  const yearDiff = getYearsDiffDates(birthDate, eventDate)

  return yearDiff ?? 'Unknown'
}
